import { render, staticRenderFns } from "./SituacaoLicitacao.vue?vue&type=template&id=14c7e154"
import script from "./SituacaoLicitacao.vue?vue&type=script&lang=ts"
export * from "./SituacaoLicitacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports